import { IFIStatus } from 'shared'
import WorkflowRollbackModal from 'components/CIMSModal/WorkflowRollbackModal'
import { useIFITrackerContext } from '../../IFITrackerContext'
import { useState } from 'react'
import { useRevertIdentifiedFieldIssueMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleSuccessNotification } from 'hooks/notificationHandler'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSComment from 'components/CIMSComment'
import { useWorkflowRollbackComment } from 'components/CIMSComment/hooks/useWorkflowRollbackComment'
import { errorHandler } from 'hooks/errorHandler'
import { dateFormatter } from '../../../../../../../../../utils/dateFormatter'

const RevertModal: React.FC = () => {
  const {
    revert: { visible, state, toggle },
    refetch,
  } = useIFITrackerContext()
  const { reportId, reviewedDate, reviewedBy } = state ?? {}
  const [loading, setLoading] = useState(false)
  const [revertFn] = useRevertIdentifiedFieldIssueMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      revertIdentifiedFieldIssue: {
        identifiedFieldIssue: { reportName },
      },
    }) => simpleSuccessNotification(`${reportName} successfully reverted!`),
  })
  return (
    <WorkflowRollbackModal
      visible={visible}
      onClose={() => toggle(null)}
      endStatus={IFIStatus.PendingReview.name}
      recordName={state?.reportName}
      affectedItems={[
        {
          label: 'Issue Review Date',
          value: reviewedDate
            ? dateFormatter.datetime(reviewedDate)
            : undefined,
        },
        {
          label: 'Issue Reviewed By',
          value: reviewedBy?.displayName ?? reviewedBy?.mail,
        },
      ]}
      formItems={
        <CIMSFormItem {...useWorkflowRollbackComment()}>
          <CIMSComment />
        </CIMSFormItem>
      }
      loading={loading}
      onOk={async ({ comment }) => {
        if (!reportId) return errorHandler('reportId is not defined')
        setLoading(true)
        await revertFn({ variables: { input: { reportId, comment } } })
        setLoading(false)
        refetch()
        toggle(null)
      }}
    />
  )
}

export default RevertModal
